const getters = {
  storeCurrent: state => state.app.storeCurrent,
}
export default getters
